import(/* webpackMode: "eager", webpackExports: ["QuickOnRamp"] */ "/vercel/path0/components/cards/quick-onramp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwapTokensForm"] */ "/vercel/path0/components/forms/swap-tokens-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserSettingsForm"] */ "/vercel/path0/components/forms/user-settings-form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SponsoredBanner"] */ "/vercel/path0/components/layout/sponsored-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedProjectsDropdown"] */ "/vercel/path0/components/modals/featured-projects-dropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogTrigger","DialogTitle","DialogContent","DialogFooter","DialogClose"] */ "/vercel/path0/components/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/components/ui/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/vercel/path0/components/ui/tabs.tsx");
